export const TestConstants = {
  leftBtnTestId: 'leftBtnTestId',
  rightBtnTestId: 'rightBtnTestId',
  paginationTestId: 'paginationTestId',
  pagTestId: 'pagtionTestId'
};
